<template>
  <button
    type="button"
    class="btn w-auto relative gap-2.5"
    :class="large ? 'btn-large' : ''"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <span
      class="flex-shrink-0 absolute left-4"
      :class="large ? '' : 'xs:static'"
    >
      <slot name="icon" />
    </span>
    <span>
      <span :class="large ? '' : 'sr-only'">
        {{ labelIntro }}
      </span>
      {{ label }}
    </span>
  </button>
</template>

<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    label: { type: String, default: '' },
    labelIntro: { type: String, default: 'Sign in with' },
  },
}
</script>
